import _extends from 'babel-runtime/helpers/extends';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import InlineEditStateless from './InlineEditStateless';

var InlineEditor = function (_Component) {
  _inherits(InlineEditor, _Component);

  function InlineEditor() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InlineEditor);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InlineEditor.__proto__ || _Object$getPrototypeOf(InlineEditor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      isEditing: false
    }, _this.onConfirm = function () {
      _this.exitEditingMode();
      var cancelConfirmation = _this.enterEditingMode;
      _this.props.onConfirm(cancelConfirmation);
    }, _this.onCancel = function () {
      _this.exitEditingMode();
      _this.props.onCancel();
    }, _this.enterEditingMode = function () {
      _this.setState({ isEditing: true });
    }, _this.exitEditingMode = function () {
      _this.setState({ isEditing: false });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InlineEditor, [{
    key: 'render',
    value: function render() {
      return React.createElement(InlineEditStateless, _extends({
        isEditing: this.state.isEditing
      }, this.props, {
        onEditRequested: this.enterEditingMode,
        onConfirm: this.onConfirm,
        onCancel: this.onCancel
      }));
    }
  }]);

  return InlineEditor;
}(Component);

InlineEditor.defaultProps = {
  label: '',
  readView: ''
};
export default InlineEditor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/inline-edit/dist/esm/InlineEdit.js
// module id = 5899
// module chunks = 0